import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { createAuthSlice, type AuthSlice } from './authSlice';
import { createNichesSlice, type NichesSlice } from './nichesSlice';
import { createAccountsSlice, type AccountsSlice } from './accountsSlice';
import { createReviewBankSlice, type ReviewBankSlice } from './reviewBankSlice';
import { createPostsSlice, type PostsSlice } from './postsSlice';
import { createPublishQueueSlice, type PublishQueueSlice } from './publishQueueSlice';
import { createProfilesSlice, type ProfilesSlice } from './profilesSlice';
import { createStatsSlice, type StatsSlice } from './statsSlice';
import { createStrategySlice, type StrategySlice } from './strategySlice';
import { createStrategyDashboardSlice, type StrategyDashboardSlice } from './strategyDashboardSlice';
import { createStrategyAccountsSlice, type StrategyAccountsSlice } from './strategyAccountsSlice';
import { createSalesCrmSlice, type SalesCrmSlice } from './salesCrmSlice';
import { createOutreachSlice, type OutreachSlice } from './outreachSlice';
import { createContentStudioSlice, type ContentStudioSlice } from './contentStudioSlice';
import { createBrandingSlice, type BrandingSlice } from './brandingSlice';
import { createBrandSlice, type BrandSlice } from './brandSlice';
import { createIgPublishingSlice, type IgPublishingSlice } from './igPublishingSlice';
import { createSatellitesSlice, type SatellitesSlice } from './satellitesSlice';
import { createRoadmapSlice, type RoadmapSlice } from './roadmapSlice';
import { createVaultSlice, type VaultSlice } from './vaultSlice';
import { createTrendingMusicSlice, type TrendingMusicSlice } from './trendingMusicSlice';
import { createVideoSlice, type VideoSlice } from './videoSlice';
import { createGoogleDriveSlice, type GoogleDriveSlice } from './googleDriveSlice';
import { createContactPoolSlice, type ContactPoolSlice } from './contactPoolSlice';
import { createClientsSlice, type ClientsSlice } from './clientsSlice';
import { createLeadGenSlice, type LeadGenSlice } from './leadGenSlice';
import { createAutopilotSlice, type AutopilotSlice } from './autopilotSlice';
import { createSSESlice, type SSESlice } from './sseSlice';
import { createLPAnalyticsSlice, type LPAnalyticsSlice } from './lpAnalyticsSlice';
import { createMindSlice, type MindSlice } from './mindSlice';
import { createLandingPageSlice, type LandingPageSlice } from './landingPageSlice';
import { createStatLibrarySlice, type StatLibrarySlice } from './statLibrarySlice';
import { createLinkedInSlice, type LinkedInSlice } from './linkedinSlice';
import { createSystemHealthSlice, type SystemHealthSlice } from './systemHealthSlice';
import { createExpansionAdvisorSlice, type ExpansionAdvisorSlice } from './expansionAdvisorSlice';
import { createCostsSlice, type CostsSlice } from './costsSlice';
import { createEmployeesSlice, type EmployeesSlice } from './employeesSlice';
import { createViewConfigSlice, type ViewConfigSlice } from './viewConfigSlice';
import { createLinkedInAccountsSlice, type LinkedInAccountsSlice } from './linkedinAccountsSlice';
import { createFirmsSlice, type FirmsSlice } from './firmsSlice';

export type StoreState = AuthSlice &
  NichesSlice &
  AccountsSlice &
  ReviewBankSlice &
  PostsSlice &
  PublishQueueSlice &
  ProfilesSlice &
  StatsSlice &
  StrategySlice &
  StrategyDashboardSlice &
  StrategyAccountsSlice &
  SalesCrmSlice &
  OutreachSlice &
  ContentStudioSlice &
  BrandingSlice &
  BrandSlice &
  IgPublishingSlice &
  SatellitesSlice &
  RoadmapSlice &
  VaultSlice &
  TrendingMusicSlice &
  VideoSlice &
  GoogleDriveSlice &
  ContactPoolSlice &
  ClientsSlice &
  LeadGenSlice &
  AutopilotSlice &
  SSESlice &
  LPAnalyticsSlice &
  MindSlice &
  LandingPageSlice &
  StatLibrarySlice &
  LinkedInSlice &
  SystemHealthSlice &
  ExpansionAdvisorSlice &
  CostsSlice &
  EmployeesSlice &
  ViewConfigSlice &
  LinkedInAccountsSlice &
  FirmsSlice;

export const useStore = create<StoreState>()(
  devtools((...args) => ({
    ...createAuthSlice(...args),
    ...createNichesSlice(...args),
    ...createAccountsSlice(...args),
    ...createReviewBankSlice(...args),
    ...createPostsSlice(...args),
    ...createPublishQueueSlice(...args),
    ...createProfilesSlice(...args),
    ...createStatsSlice(...args),
    ...createStrategySlice(...args),
    ...createStrategyDashboardSlice(...args),
    ...createStrategyAccountsSlice(...args),
    ...createSalesCrmSlice(...args),
    ...createOutreachSlice(...args),
    ...createContentStudioSlice(...args),
    ...createBrandingSlice(...args),
    ...createBrandSlice(...args),
    ...createIgPublishingSlice(...args),
    ...createSatellitesSlice(...args),
    ...createRoadmapSlice(...args),
    ...createVaultSlice(...args),
    ...createTrendingMusicSlice(...args),
    ...createVideoSlice(...args),
    ...createGoogleDriveSlice(...args),
    ...createContactPoolSlice(...args),
    ...createClientsSlice(...args),
    ...createLeadGenSlice(...args),
    ...createAutopilotSlice(...args),
    ...createSSESlice(...args),
    ...createLPAnalyticsSlice(...args),
    ...createMindSlice(...args),
    ...createLandingPageSlice(...args),
    ...createStatLibrarySlice(...args),
    ...createLinkedInSlice(...args),
    ...createSystemHealthSlice(...args),
    ...createExpansionAdvisorSlice(...args),
    ...createCostsSlice(...args),
    ...createEmployeesSlice(...args),
    ...createViewConfigSlice(...args),
    ...createLinkedInAccountsSlice(...args),
    ...createFirmsSlice(...args),
  }))
);
